import logo from './logo.svg';
import './App.scss';
import React from "react";
import {
  BrowserRouter as Router,
  Switch, 
  Route,
  NavLink
} from "react-router-dom";
import Players from "./pages/players/players";
import InitializeGame from "./pages/game/InitializeGame";
import Game from './pages/game/Game';


function App() {
  return (
    <Router>
      <div className="app-container">
        <Switch>
          <Route path="/players">
            <Players/>
          </Route>
          <Route path="/select-players">
            <InitializeGame/>
          </Route>
          <Route path="/game">
            <Game/>
          </Route>
        </Switch>

        <nav className="nav-container">
          <ul className="nav-bar">
            <li className="selected">
              <NavLink exact to="/" activeClassName="selected">Home</NavLink>
            </li>
            <li className="selected">
              <NavLink exact to="/players" activeClassName="selected">Players</NavLink>
            </li>
            <li className="selected">
              <NavLink exact to="/game" activeClassName="selected">Game</NavLink>
            </li>
          </ul>
        </nav>
      </div>
    </Router>
  );
}

export default App;
